﻿'use strict'

import '../vendor/fontawesome-free/js/all.js'

import { useLightbox } from './utility/_glightbox.js'

let documentReady = (fn) => {
    document.readyState === 'interactive' || document.readyState === 'complete'
        ? fn()
        : document.addEventListener('DOMContentLoaded', fn)
}


documentReady(() => {
    useLightbox()

})